import axios from 'axios';
import { API_CONFIG } from './config';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS,
});

// Request interceptor - Add auth token to requests
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('authToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log request in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    }

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor - Handle responses and errors
api.interceptors.response.use(
  (response) => {
    // Log response in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`✅ API Response: ${response.config.url}`, response.data);
    }

    // Transform backend response format to frontend format
    const backendData = response.data;

    return {
      success: !backendData.error,
      data: backendData.data,
      pagination: backendData.pagination,
      summary: backendData.summary,
      message: backendData.message,
      error: backendData.error ? backendData.message : null,
    };
  },
  (error) => {
    console.error('Response Error:', error);

    // Handle different error types
    if (error.response) {
      // Server responded with error status
      const backendError = error.response.data;

      // Log error in development
      if (process.env.NODE_ENV === 'development') {
        console.error(`❌ API Error: ${error.response.status}`, backendError);
      }

      // Handle 401 Unauthorized - redirect to login
      if (error.response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        window.location.href = '/';
      }

      return {
        success: false,
        data: null,
        message: backendError.message || 'An error occurred',
        error: backendError.message || error.message,
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        success: false,
        data: null,
        message: 'No response from server. Please check your connection.',
        error: 'Network error',
      };
    } else {
      // Error in request configuration
      return {
        success: false,
        data: null,
        message: error.message,
        error: error.message,
      };
    }
  }
);

export default api;
